import { Component, Input, OnInit } from '@angular/core'
import { ThemeSwitcherService } from '../../../../core/services/theme-switcher.service'

interface Action {
    icon: string
    handler: () => void
}
@Component({
    selector: 'app-form-header',
    templateUrl: './form-header.component.html',
    styleUrls: ['./form-header.component.scss'],
})
export class FormHeaderComponent implements OnInit {
    @Input() title = 'None'
    @Input() actions: Action[] = []
    @Input() headerStyle = {}
    @Input() titleStyle = {}

    constructor(public themeService: ThemeSwitcherService) {}

    ngOnInit(): void {}

    hasActions() {
        return this.actions.length > 0
    }
}
